module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.userIsAdmin()) ? _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "clipped": _vm.$vuetify.breakpoint.lgAndUp,
      "app": ""
    },
    on: {
      "input": _vm.drawerStatusCatch
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('app-menu')], 1) : _vm._e(), _vm._v(" "), _c('app-toolbar', {
    attrs: {
      "drawer": _vm.drawer
    },
    on: {
      "drawerStatus": _vm.drawerStatusCatch
    }
  }), _vm._v(" "), _c('v-content', [_c('keep-alive', [_c('router-view', {
    key: _vm.$route.path
  })], 1)], 1), _vm._v(" "), _c('app-notification')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c208638","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 356
// module chunks = 4